/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_Tab_EventsInputs */

const en_booking_portal_tab_events = /** @type {(inputs: Booking_Portal_Tab_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const pl_booking_portal_tab_events = /** @type {(inputs: Booking_Portal_Tab_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Booking_Portal_Tab_EventsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_tab_events = /** @type {((inputs?: Booking_Portal_Tab_EventsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Tab_EventsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_tab_events(inputs)
	return en_booking_portal_tab_events(inputs)
});